import FindControlViewState from 'owa-recipient-types/lib/types/FindControlViewState';
import { FeedbackManagerState } from 'owa-feedback-manager/lib/store/schema/FeedbackManagerState';
import {
    FindResultType,
    DirectorySearchType,
} from 'owa-recipient-types/lib/types/FindControlViewState';

export default function createFindControlViewState(
    queryString?: string,
    findPeopleFeedbackManager?: FeedbackManagerState,
    inForceResolve?: boolean
): FindControlViewState {
    let findControlViewState: FindControlViewState = {
        queryString: queryString ? queryString : '',
        findResultSet: [],
        findResultType: FindResultType.None,
        isSearching: false,
        directorySearchType: DirectorySearchType.None,
        findPeopleFeedbackManager: findPeopleFeedbackManager,
        inForceResolve: inForceResolve,
        currentRenderedQueryString: '',
    };

    return findControlViewState;
}
